import { useContext } from 'react';

import BillingContext from './BillingContext';

const useBilling = () => useContext(BillingContext);

export default useBilling;
